import {useLazyQuery} from '@apollo/client/react';
import {extractGqlData} from '@coolcolduk/ui-apollo-client';
import type {Prompt} from '@cp/model';
import {GENERATE_QUESTION_WITH_SEED_PROMPTS} from '../sharedQueries';

export interface GenerateQuestionWithSeedPromptsVariables {
  moduleId: string;
  topic?: string;
  seedQuestionId: string;
  numberOfVariants?: number;
  additionalInfo?: string;
}

export function useGenerateQuestionWithSeedPrompts() {
  const [generatePrompts, {loading, error}] = useLazyQuery<
    {generateQuestionWithSeedPrompts: Prompt},
    GenerateQuestionWithSeedPromptsVariables
  >(GENERATE_QUESTION_WITH_SEED_PROMPTS);

  const generateQuestionWithSeedPrompts = async (variables: GenerateQuestionWithSeedPromptsVariables) => {
    const result = await generatePrompts({variables});
    return extractGqlData(result).generateQuestionWithSeedPrompts;
  };

  return {
    generateQuestionWithSeedPrompts,
    loading,
    error,
  };
}
